const glosary = ['hora no lectiva', 'hora sep 1', 'hora sep 2', 'hora sep 3' , 'aula media', 'aula básica', 'flotancia', 'recreo docente', 'colaboración',
  ,'pie básica', 'pie media', 'turno de patio', 'complementaria', '']

const glosary_abreviations = [{value: 'hora no lectiva', abreviation: 'HNL', type:'non_academic'}, {value: 'hora sep 1', abreviation: 'HS1', type: 'sep_1'}, 
                            {value: 'hora sep 2', abreviation: 'HS2', type:'sep_2'}, {value: 'aula media', abreviation: 'AM', type: 'high_classroom'},
                            {value: 'aula básica', abreviation: 'AB', type: 'middle_classroom'}, {value: 'flotancia', abreviation: 'FTL', type: 'float'},
                            {value: 'recreo docente', abreviation: 'DSC', type: 'break'}, {value: 'colaboración', abreviation: 'COL', type:'colab'},
                            {value: 'complementaria', abreviation: 'COL', type:'colab'}, 
                            {value: 'pie básica', abreviation: 'PIEB', type: 'pie_middle_classroom'}, {value: 'pie media', abreviation: 'PIEM', type: 'pie_high_classroom'},
                            {value: 'hora sep 3', abreviation: 'HS3', type:'sep_3'}, {value: 'turno de patio', abreviation: 'TP', type: 'yard_turn'}]

export {glosary, glosary_abreviations}


// WEBPACK FOOTER //
// ./src/components/home/glosary.js